import { render, staticRenderFns } from "./BuildingInformation.vue?vue&type=template&id=71f14ff0"
import script from "./BuildingInformation.vue?vue&type=script&lang=js"
export * from "./BuildingInformation.vue?vue&type=script&lang=js"
import style0 from "./BuildingInformation.vue?vue&type=style&index=0&id=71f14ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports